/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Room, RoomEvent, DataPacket_Kind } from "livekit-client";
import { TNotifyFileChangeData } from "@/types/public";
import { useNotifications } from "../room/useNotifications";

export function useReceiveFileChange(
  target: "file",
  room: Room | null | undefined,
  toggleHandler: (data: TNotifyFileChangeData) => void
) {
  const { permission, requestPermission, showNotification } =
    useNotifications();

  useEffect(() => {
    if (!room) return;

    const decoder = new TextDecoder();

    const handler = async (
      data: Uint8Array,
      _participant?: any,
      _kind?: DataPacket_Kind,
      topic?: string
    ) => {
      if (topic !== target) return;

      try {
        if ("Notification" in window) {
          if (permission === "granted") {
            showNotification("File changed", {
              sound: "success",
              body: "A shared file was updated.",
              icon: "/icon-192.png",
              badge: "/badge-72.png",
              tag: "file-change",
            });
          } else if (permission === "default") {
            const res = await requestPermission();
            if (res === "granted") {
              showNotification("File changed", {
                sound: "success",
                body: "A shared file was updated.",
                icon: "/icon-192.png",
                badge: "/badge-72.png",
                tag: "file-change",
              });
            }
          }
        }
      } catch (e) {
        console.warn("Notification error:", e);
      }

      try {
        const parsed = JSON.parse(
          decoder.decode(data)
        ) as TNotifyFileChangeData;
        toggleHandler(parsed);
      } catch (e) {
        console.error("Failed to parse file-change data:", e);
      }
    };

    room.on(RoomEvent.DataReceived, handler);
    return () => {
      room.off(RoomEvent.DataReceived, handler);
    };
  }, [
    room,
    target,
    toggleHandler,
    permission,
    requestPermission,
    showNotification,
  ]);
}
